import { useTranslation } from 'react-i18next';

import { OpPage } from 'new-components/OpPage/OpPage';

import GuestPassLogTable from './GuestPassLogTable';

const GuestPassLog = () => {
  const { t } = useTranslation();
  return (
    <OpPage title={t('guestPassLog.title')}>
      <GuestPassLogTable />
    </OpPage>
  );
};

export default GuestPassLog;
